import { Platform, setupRenderClient } from '../common';
import { mfeRendererFactory } from './mfe-renderer';
import { loadRootConfig, loadFeatureFlagConfig } from './config-loader';
import { loadUserLocation } from './location-loader';
import { loadUserData } from './user-data-loader';
import { IdentificationInfo } from '@combinativ/client-api';
import { loggerFactory } from '../common/logger';

const rootIdentificationInfo: IdentificationInfo = {
    name: 'combinativ-client',
    squad: 'platform',
};

/**
 * Perform the initial setup of Combinativ.js client. This is called when the page load.
 */
export function bootstrap() {
    const kiwiLogger = loggerFactory(rootIdentificationInfo);

    const rootConfig = loadRootConfig();
    const featureFlagConfig = loadFeatureFlagConfig();
    const userLocation = loadUserLocation();
    const userData = loadUserData();
    return setupRenderClient({
        logger: kiwiLogger,
        platform: Platform.Kiwi,
        rootConfig,
        featureFlagConfig,
        userLocation,
        userData,
        bootstrap: ({ appLoader, logger }) => {
            mfeRendererFactory({ appLoader, logger });
        },
    });
}
